import React, { useState } from 'react';
import { AxiosResponse } from 'axios';
import { Article, GetArticulosPorFiltro, ModoBusqueda } from '@/objects/Articles';
import { urlWeb } from '@/util/BaseURL';
import ArticulosQueries from '@/network/Articulos';
import { HeadObj } from '@/objects/Page';
import ListaArticulos from '@/components/elements/listas/lista_articulos/ListaArticulos';
import { crearJSONLDCatalogo, numeroCajasPorDefecto, obtenerCategoriaIDByString, obtenerCategoriaStringByID } from '@/util/Articulos';
import { pathToSection, traduccionesPorPathHead } from '@/util/internacionalizacion/TraduccionesPorPath';
import { useTranslation } from "next-i18next"
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import ContenidoPrincipal from '@/components/elements/ContenidoPrincipal';
import TituloPrincipalH1 from '@/components/elements/TituloPrincipalH1';
import { axiosBaseURLAPI } from '@/util/NetworkInstance';
import { idiomasDisponibles } from '@/util/Comun';

interface HomeProps {
  articles: Article[];
  getArticulosPorFiltro: GetArticulosPorFiltro;
  pathActual: string;
}
const LibrosUsadosOfertaIndex: React.FC<HomeProps> = ({ articles, getArticulosPorFiltro, pathActual }) => {
  //Importante siempre tiene que ser de next-i18next no de react-i18next
  const { t } = useTranslation();

  //const { usersQueries } =   useServices();

  const [articlesState, setArticlesState] = useState(articles);

  return (
    <ContenidoPrincipal
      leftComponent={<div>Anuncio</div>}
      centerComponent={
        <>
          <TituloPrincipalH1 texto={t(`contenido:${pathActual}.titulo`)} />
          <ListaArticulos articles={articlesState} t={t} link={"/libros-usados-oferta/" + obtenerCategoriaStringByID(getArticulosPorFiltro.valorcategoria!) + "/" + getArticulosPorFiltro.last_id} />
        </>
      }
      rightComponent={<div>Anuncio 2</div>}
    />
  );
};

export default LibrosUsadosOfertaIndex;


//Generacion de articulos en el servidor para SEO
export async function getServerSideProps(context: any) {
  //Obtener categoria y last_id del path
  let { params, locale } = context;
  const { categoria } = params;

  const last_id = 0;

  if (!locale) {
    locale = 'es'; // Reemplaza 'es' con tu localización predeterminada
  }

  if (isNaN(Number(last_id))) {
    //Devuelve 404
    return {
      notFound: true,
    };
  }

  const getArticulosPorFiltro: GetArticulosPorFiltro = {
    valorcategoria: obtenerCategoriaIDByString(categoria),
    modo_busqueda: ModoBusqueda.RECIENTES,
    limit: numeroCajasPorDefecto(),
    last_id: Number(last_id)
  };

  const pathActual = pathToSection(context.resolvedUrl);
  //console.log('Path actual:', pathActual);
  //console.log('Idioma Cookie:' + getCookiePais(context));
  const headerObj: HeadObj = await traduccionesPorPathHead(context, locale);

  let articulos: Article[] = [];

  try {
    const articulosQueries = new ArticulosQueries(axiosBaseURLAPI());

    const response: AxiosResponse<Article[]> = await articulosQueries.getArticulosFiltro(getArticulosPorFiltro, "web-ssr-libros-usados-oferta-categoria");

    //console.log('Artículos:', response.data.articles);
    articulos = response.data;

    //headerObj.JSONLDPage = crearJSONLDCatalogo(articles);

    headerObj.JSONLDPage = crearJSONLDCatalogo(articulos);

    //Crea el link canonical y los alternates
    let ultimoIdCanonical: string = "";

    if (locale === 'es') {
      headerObj.linkCanonical = `${urlWeb}/libros-usados-oferta/${categoria}${ultimoIdCanonical}`;
    } else {
      headerObj.linkCanonical = `${urlWeb}/${locale}/libros-usados-oferta/${categoria}${ultimoIdCanonical}`;
    }

    headerObj.alternates = idiomasDisponibles.map((loc) => {
      if (loc === 'es') {
        return { hreflang: loc, href: `${urlWeb}/libros-usados-oferta/${categoria}${ultimoIdCanonical}` };
      } else {
        return { hreflang: loc, href: `${urlWeb}/${loc}/libros-usados-oferta/${categoria}${ultimoIdCanonical}` };
      }
    });


    //Set de ultima id categoria
    getArticulosPorFiltro.last_id = articulos[articulos.length - 1].id_article;
  } catch (error) {
    console.error('Error al obtener artículos:', error);
  }
  //console.log("ServerSideTranslation Indice" + JSON.stringify(await serverSideTranslations(locale, ['common', "contenido"])));
  return {
    props: {
      articles: articulos,
      headerObj: headerObj, // Pasar el objeto de encabezado
      getArticulosPorFiltro: getArticulosPorFiltro,
      pathActual: pathActual,
      ...(await serverSideTranslations(locale, ['common', "contenido", "header"])),
    },
  };
}